// extracted by mini-css-extract-plugin
module.exports = {"root":"NoSurveys_root__a2HrN","message":"NoSurveys_message__JlnR4","image":"NoSurveys_image__Ji8zp"};